// Imports
import { Helmet } from 'react-helmet-async';


// Define the accepted props
interface Props {
	statusCode: number;
}


// Function component
const PrerenderStatusCode: React.FC<Props> = ({ statusCode }) => {
	// Throw if the status code isn't a valid HTTP status code
	if (statusCode < 200 || statusCode >= 600) {
		throw new Error(`Invalid prerender status code: ${statusCode}`);
	}
	
	
	// Return JSX
	return (
		<Helmet>
			<meta name='prerender-status-code' content={String(statusCode)} />
		</Helmet>
	);
};

export default PrerenderStatusCode;
